"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var NAV_TREE_PADDING_BASIS = 1;
var NAV_TREE_MAX_DEPTH = 25;
var NAV_TREE_DEPTHS = (Array.from(Array(NAV_TREE_MAX_DEPTH)).reduce(function (acc, _v, i) {
    acc["&.depth-" + i] = { paddingLeft: i * NAV_TREE_PADDING_BASIS + "rem" };
    return acc;
}, {}));
var navTreeBaseTheme = function (_breakpoints) { return ({
    overrides: {
        MuiTreeItem: {
            root: {
                "&$selected": {
                    "backgroundColor": "initial"
                }
            },
            label: {
                "&:hover": {
                    backgroundColor: 'initial'
                }
            }
        }
    },
    navTreeIcon: {},
    navTreeItemSelected: {},
    navTreeItemExpanded: {},
    navTreeItemGroup: {},
    navTreeItemOnHotPath: {},
    navTreeItemLabel: {
        display: "inherit",
        color: "inherit",
        padding: "0.5rem 0",
        fontSize: "0.875rem",
        marginLeft: "0.375rem",
    },
    navTreeItemLabelSelected: {},
    navTreeItemLabelBinary: {},
    navTreeItemHoverDisable: {},
    navTreeItem: __assign(__assign({}, NAV_TREE_DEPTHS), { flexDirection: "row" }),
    navTree: {
        iconExpand: "chevron_right",
        iconCollapse: "expand_more",
        loadingSpinner: {
            thickness: 3,
            variant: "indeterminate",
            size: "8rem"
        }
    },
    navTreeLoading: {
        display: "flex",
        flex: 1,
        height: "100%"
    },
    navTreeLoadingSpinner: {
        alignSelf: "center",
        margin: "0 auto"
    },
}); };
exports.default = navTreeBaseTheme;
//# sourceMappingURL=navTree.js.map